/* eslint-disable react/jsx-key */
import { type FC, type ReactElement } from 'react';
import {
  NewOpenings,
  Families,
  Suitcase,
  Snowflake,
  Beach,
  CountrySide,
  Balloon,
  Gift,
  Wellness,
} from '.';

import { InspirationCategoriesProps } from './types';

const InspirationCategoriesIcons: FC<InspirationCategoriesProps> = ({
  icon,
  ...props
}) => {
  const icons = new Map<string, ReactElement>([
    ['star', <NewOpenings {...props} />],
    ['family', <Families {...props} />],
    ['suitcase', <Suitcase {...props} />],
    ['snowflake', <Snowflake {...props} />],
    ['beach', <Beach {...props} />],
    ['countryside', <CountrySide {...props} />],
    ['balloon', <Balloon {...props} />],
    ['gift', <Gift {...props} />],
    ['leaf', <Wellness {...props} />],
  ]);
  return icons.get(icon) || <></>;
};

export default InspirationCategoriesIcons;
